import React, { useState, useEffect } from "react";
import Tick from "../../../../_Pages/_webapp/Auction/CreateAuction/tick";

import styles from "./styles.module.css";

const ThankYouScreen = (props) => {
  return (
    <div>
      <div className={`${styles["thankuticklac"]} m-auto`}>
        <Tick height={34} width={35} />
      </div>
      <h3 className="text-center mt-3">Thank you!!</h3>
      <div className="p-2 fw500 text-center">KYC registration successful</div>
      <div className="p-2 text-center">
        Our business team will get in touch with you soon.
      </div>
    </div>
  );
};

export default ThankYouScreen;
